const CHUNK_ERROR_PATTERN =
  /Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk/;

export function lazyRetry(
  importFn: () => Promise<any>,
  retries = 2,
  delay = 1500
): Promise<any> {
  return importFn().catch(err => {
    const isChunkError = CHUNK_ERROR_PATTERN.test(err?.message);
    if (!isChunkError || retries <= 0) throw err;
    return new Promise(resolve => setTimeout(resolve, delay))
      .then(() => lazyRetry(importFn, retries - 1, delay));
  });
}
